"use strict";
/*
  PutCallFlag: Either "put" or "call"
  S: Stock Price
  K: Strike Price
  T: Time to expiration (in years)
  r: Risk-free rate
  v: Volatility
  Taken from http://www.espenhaug.com/black_scholes.html
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.blackScholes = void 0;
const types_1 = require("../types");
const statisticsUtils_1 = require("./statisticsUtils");
const blackScholes = (optionType, St, K, _timeToExpiry, r, v) => {
    // if timeToExpiry is really 0 we get NaN at strike
    let timeToExpiry = _timeToExpiry <= 0 ? 0.00000001 : _timeToExpiry;
    const d1 = (Math.log(St / K) + (r + (v * v) / 2) * timeToExpiry) /
        (v * Math.sqrt(timeToExpiry));
    const d2 = d1 - v * Math.sqrt(timeToExpiry);
    const ert = Math.exp(-r * timeToExpiry);
    if (optionType === types_1.OptionType.CALL) {
        return St * (0, statisticsUtils_1.CND)(d1) - K * ert * (0, statisticsUtils_1.CND)(d2);
    }
    else {
        return K * ert * (0, statisticsUtils_1.CND)(-d2) - St * (0, statisticsUtils_1.CND)(-d1);
    }
};
exports.blackScholes = blackScholes;
